import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ComponentBase } from 'src/app/base-classes/componet-base';
import { ActivatedRoute } from '@angular/router';
import { InterCopmonentDataCarrierService } from 'src/app/services/inter-copmonent-data-carrier-service/inter-copmonent-data-carrier.service';
import { RoutingService } from 'src/app/services/routing-service/routing.service';
import { PrifactRoute } from 'src/app/models/prifact-route';
import { Device } from '@ionic-native/device/ngx';
import { SettingsService } from 'src/app/services/settings/settings.service';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { S3Service } from 'src/app/services/s3-service/s3-service.service';
import { switchMap, tap, filter } from 'rxjs/operators';
import { Observable, combineLatest } from 'rxjs';
import { HomeworksService } from '../../services/homeworks.service';
import { Homework } from '../../models/homework';
import { UploadFile } from '../../models/upload-file';
import { Error } from '../../../../common/errors/error';

@Component({
  selector: 'app-submit-homework',
  templateUrl: './submit-homework.component.html',
  styleUrls: ['./submit-homework.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SubmitHomeworkComponent extends ComponentBase implements OnInit {

  constructor(private route: ActivatedRoute
    , private interComponentService: InterCopmonentDataCarrierService
    , private routingService: RoutingService
    , private loaderService: LoaderService
    , private s3Service: S3Service
    , private homeworksService: HomeworksService
    , public device: Device
    , public settingsService: SettingsService) {
    super();
   }

  selectedHomework: Homework; 
  loading: boolean = true;
  description: string;
  supportedContentTypes: Array<string>;
  selectedFiles: File[] = [];
  emptyDescription: boolean = false;
  filesToUpload: Array<UploadFile> = [];
  selectedFileKeys: Array<number> = [];
  isButtonsDisabled: boolean = false;
  showProgress: boolean = false;
  fileUploadProgress: Array<any> = [];
  maxFileSize: number;
  fileUploadErrors: Array<Error> = [];
  showSubmissionConfirm: boolean = false;

  ngOnInit() {
    let sub1 = this.route.params.pipe(
      switchMap(params => {
        return this.homeworksService.getHomeworkById(params["homeworkId"])
      })
    ).subscribe(res => {
      this.loading = false;
      this.selectedHomework = res;
      if(this.selectedHomework.submitted_date != null){
        let route = new PrifactRoute();
        route.primary_command = ['pages', 'homeworks'];
        route.clear_history = true;
        this.routingService.navigate(route);
      }
    })
    this.addSubscription(sub1);

    let sub2 = this.settingsService.getSettings()
      .subscribe(res => {
        this.supportedContentTypes = res.home_work_content_types;
        this.maxFileSize = res.homework_file_max_size;
      });
    this.addSubscription(sub2);
  }

  confirmSubmission(event: boolean){
    this.showSubmissionConfirm = false;
    if (this.selectedFiles.length > 0) {
      this.loaderService.requestStart();
      this.isButtonsDisabled = true;

      this.selectedFiles.forEach(file => {
        var obj = new UploadFile();
        obj.file_name = file.name;
        obj.file_size = file.size;
        obj.file_type = file.type;
        this.filesToUpload.push(obj);
      });

      this.s3Service.getPresignedUrl(this.filesToUpload, "assignment-submissions").pipe(
        switchMap(res => {
          const s3result: Array<Observable<any>> = [];
          this.selectedFiles.forEach((file, i) => {
            this.selectedFileKeys.push(+res[i].file_key)
            s3result.push(this.s3Service.uploadFile(res[i].url, res[i].content_type, file));
          });

          return combineLatest(s3result);
        }),
        tap(progress => {
          this.showProgress = true;
          this.fileUploadProgress = [];
          this.filesToUpload.forEach((file, i) => {
            if (progress[i].type != 4 && progress[i].type != 0) {
              this.fileUploadProgress.push({
                "file_name": file.file_name,
                "progress": Math.round(progress[i].loaded * 100 / progress[i].total)
              });
            }
          });
        }),
        filter(progress => {
          if (progress.find(o => o.type != 4)) {
            return false;
          }
          return true;
        }),
        switchMap(_ => {
          this.loaderService.requestComplete();
          return this.homeworksService.submitHomework(this.selectedHomework.home_work_id, this.description, this.selectedFileKeys);
        })
      ).subscribe(_ => {
        this.isButtonsDisabled = false;
        this.redirectToHomeworks();
      }, err => {
        this.fileUploadErrors = err;
        this.isButtonsDisabled = false;
        this.loaderService.requestComplete();
      }
      );
    }

    else {
      let sub = this.homeworksService.submitHomework(this.selectedHomework.home_work_id, this.description)
        .subscribe(_ => {
          this.redirectToHomeworks();
        });
      this.addSubscription(sub);
    }
  }

  cancelSubmission(event: boolean){
    this.showSubmissionConfirm = false;
  }

  onSubmit() {
    this.fileUploadErrors = [];
    this.emptyDescription = false;
    this.filesToUpload = [];
    this.selectedFileKeys = [];

    if(this.description){
      this.showSubmissionConfirm = true;
    }
    else{
      this.emptyDescription = true;
    }
  }

  onFileSelect(files: Array<File>) {
    this.selectedFiles = files;
  }


  redirectToHomeworks(){
    let route = new PrifactRoute();
    route.url = '/pages/homeworks';
    route.append_current_url_to_history = true;
    this.routingService.navigate(route);
  }
}
